//initial redux
import { put, call, takeEvery, fork, all, takeLatest, select, take } from "redux-saga/effects";
import { Interval, Point, PointDisplay } from "../../../services/Live/types";
import ruleservice from "../../../services/rules";
import { TreeFlatener, TreeMap, DateTime, AsyncSaga, persist } from "../../../utils";
import { types as sitetreetypes, actions as sitetreeactions} from "../../../services/SiteTree/redux";
import moment from "moment";
import { ManualPromise } from "../../../boot/http";
import * as router from "react-router-redux";
import { types as searchtypes } from "../../../components/SearchBar/redux";
import { actions as searchactions } from "../../../components/SearchBar/redux";
import { types as timetypes } from "../../../redux/timeRedux";

const initialState = {
      map: {_children: []},
      rerender: 0,
      calendarOpen: false,
      filter: "all",
      siteName: "all",
      defaultSite: { name: "Site_22SHO" },

      isBusy: false,
      errors: [],
      toBeOpened: [],
      loadedSite: null,
      loadedTime: null,

      searchText: "",
      hasSearched: false,
      isSearchBusy: false,
      searchResults: 0,

      timeoutId: null,
};

const persistConf = {
	whitelist: ["loadedTime", "siteName", "map"]
};

/////////
//types
export const types = {
      GET_RULE_CATEGORIES: "screens/rules/GET_RULE_CATEGORIES",
      ON_GET_RULE_CATEGORIES: "screens/rules/ON_GET_RULE_CATEGORIES",
      ON_GET_RULE_CATEGORIES_FAILED: "screens/rules/ON_GET_RULE_CATEGORIES_FAILED",

      GET_RULEINSTS_FOR_RULE: "screens/rules/GET_RULEINSTS_FOR_RULE",
      ON_GET_RULEINSTS_FOR_RULE: "screens/rules/ON_GET_RULEINSTS_FOR_RULE",
      ON_GET_RULEINSTS_FOR_RULE_FAILED: "screens/rules/ON_GET_RULEINSTS_FOR_RULE_FAILED",


      CHANGE_FILTER: "screens/rules/CHANGE_FILTER",

      TOGGLE_CALENDAR: "screens/rules/TOGGLE_CALENDAR",
      TOGGLE_OPEN_CATEGORY: "screens/rules/TOGGLE_OPEN_CATEGORY",
      ON_TOGGLE_OPEN_CATEGORY: "screens/rules/ON_TOGGLE_OPEN_CATEGORY",
      TOGGLE_OPEN_RULE: "screens/rules/TOGGLE_OPEN_RULE",
      RESET_RULE_CATEGORIES: "screens/rules/RESET_RULE_CATEGORIES",
      ON_RESET_RULE_CATEGORIES: "screens/rules/ON_RESET_RULE_CATEGORIES",

      SET_SEARCH_VALUE: "screens/rules/SET_SEARCH_VALUE",
      SET_SEARCH_TEXT: "screens/rules/SET_SEARCH_TEXT",
      CLEAR_SEARCH: "screens/rules/CLEAR_SEARCH",
      SEARCH: "screens/rules/SEARCH",
      ON_SEARCH: "screens/rules/ON_SEARCH",
      SET_SEARCH_BUSY: "screens/rules/SET_SEARCH_BUSY",

      GET_OUTCOMES_FOR_RULE_INST: "screens/rules/GET_OUTCOMES_FOR_RULE_INST",
      ON_GET_OUTCOMES_FOR_RULE_INST: "screens/rules/ON_GET_OUTCOMES_FOR_RULE_INST",
      ON_GET_OUTCOMES_FOR_RULE_INST_FAILED: "screens/rules/ON_GET_OUTCOMES_FOR_RULE_INST_FAILED",

      SET_TIMEOUT: "screens/rules/SET_TIMEOUT",
      CLEAR_TIMEOUT: "screens/rules/CLEAR_TIMEOUT",
};

///////////
//reducers
const reducers = {
      reducer(state = initialState, action) {
            switch (action.type) {
                  case types.GET_RULE_CATEGORIES:
                        return { ...state, isBusy: true, siteName: action.payload.siteName };
                  case types.ON_GET_RULE_CATEGORIES:
                        return { ...state, isBusy: false, map: action.payload.map, toBeOpened: [], loadedSite: action.payload.siteName, loadedTime: action.payload.time, rerender: state.rerender + 1 };
                  case types.ON_GET_RULE_CATEGORIES_FAILED:
                        return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };

                  case types.ON_GET_RULEINSTS_FOR_RULE:
                        return { ...state, isBusy: false, map: action.payload, rerender: state.rerender + 1 };
                  case types.ON_GET_RULEINSTS_FOR_RULE_FAILED:
                        return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };

                  case types.ON_GET_OUTCOMES_FOR_RULE_INST:
                        return { ...state, isBusy: false, map: action.payload, rerender: state.rerender + 1 };
                  case types.ON_GET_OUTCOMES_FOR_RULE_INST_FAILED:
                        return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };

                  case types.ON_TOGGLE_OPEN_CATEGORY: {
                        return { ...state, map: action.payload, rerender: state.rerender + 1 };
                  }
                  case types.TOGGLE_CALENDAR:
                        return { ...state, calendarOpen: !state.calendarOpen };

                  case types.CHANGE_FILTER:
                        return { ...state, isBusy: action.payload.filter !== state.filter, filter: action.payload.filter, map: new TreeMap() };

                  case types.SET_TIMEOUT:
                        return { ...state, timeoutId: action.payload };
                  case types.CLEAR_TIMEOUT:
                        return { ...state, timeoutId: null };

                  case types.ON_RESET_RULE_CATEGORIES:
                        return { ...state, map: {_children: []}, toBeOpened: action.payload }

                  case types.SET_SEARCH_VALUE:
                        return { ...state, searchValue: action.payload}
                  case types.SET_SEARCH_TEXT:
                        return { ...state, searchText: action.payload}
                  case types.CLEAR_SEARCH:
                        return { ...state, hasSearched: false, searchResults: 0}
                  case types.SEARCH:
                        return { ...state, isSearchBusy: true}
                  case types.SET_SEARCH_BUSY:
                        return { ...state, isSearchBusy: true}
                  case types.ON_SEARCH:
                        return { ...state, hasSearched: true, map: action.payload.map, searchResults: action.payload.numOfResults, isSearchBusy: false}

                  default:
                        return state;
            }
      }
};
export const reducer = persist("rules", reducers.reducer, persistConf);

function addCategoryToNode(node, category, categories) {
      if(category.length > 0) {
            let shift = category.shift();
            let found = node._children.find(x => x.title === shift);
            if(found) {
                  found.numRules = found.numRules !== undefined ? found.numRules + categories.numRules : categories.numRules;
                  found.failedRules = found.failedRules !== undefined ? found.failedRules + categories.failedRules : categories.failedRules; 
                  addCategoryToNode(found, category, categories);
            } else {
                  node._children.push({title: shift, _isOpen: false, _children: [], numRules: categories.numRules, failedRules: categories.failedRules });
                  addCategoryToNode(node._children[node._children.length - 1], category, categories);
            }
      } else {
            node.hasRules = true;
            node.ruleCategoryCode = categories.ruleCategoryCode;
      }
}

function addCategoriesToRoot(node, categories) {
      let split = categories.description.split("->");
      addCategoryToNode(node, split, categories);
}

function findAndAddRules(parentNode, node, rules) {
      if(parentNode === node) {
            parentNode.rules = rules;
            return true;
      }

      for(var ii = 0; ii < parentNode._children.length; ii++) {
            let result = findAndAddRules(parentNode._children[ii], node, rules);
            if(result) {
                  return true;
            }
      }

      return false;
}

function findAndAddRuleOutcomes(parentNode, ruleInstanceId, outcomes) {
      if(parentNode.rules && parentNode.rules.length > 0) {
            for(var ii = 0; ii < parentNode.rules.length; ii++) {
                  if(parentNode.rules[ii].ruleInstanceId == ruleInstanceId) {
                        parentNode.rules[ii].outcomes = outcomes;
                        return true;
                  }
            }
      }

      for(var ii = 0; ii < parentNode._children.length; ii++) {
            let result = findAndAddRuleOutcomes(parentNode._children[ii], ruleInstanceId, outcomes);
            if(result) {
                  return true;
            }
      }
      
      return false;
}

function closeNode(node) {
      node._isOpen = false;
      if(node._children.length > 0) {
            node._children.forEach(n => {
                  closeNode(n);
            });
      }
}

function findAndToggle(parentNode, node) {
      if(parentNode === node) {
            parentNode._isOpen = !parentNode._isOpen;
            if(parentNode._isOpen === false) {
                  closeNode(parentNode);
            }
            return true;
      }

      for(var ii = 0; ii < parentNode._children.length; ii++) {
            let result = findAndToggle(parentNode._children[ii], node);
            if(result) {
                  return true;
            }
      }

      return false;
}

function addSearchedRules(node, category, rule) {
      if(category.length > 0) {
            let shift = category.shift();
            let found = node._children.find(x => x.title === shift);
            if(found) {
                  addSearchedRules(found, category, rule);
            } else {
                  node._children.push({title: shift, _isOpen: true, _children: []});
                  addSearchedRules(node._children[node._children.length - 1], category, rule);
            }
      } else {
            node.hasRules = true;

            node.hasRules = true;
            if(!node.rules || node.rules.length === undefined) {
                  node.rules = [];
            }
            node.rules.push(rule);
            node._isOpen = true;
            node.ruleCategoryCode = rule.ruleCategoryCode;
      }
}

function searchedRules(node, rules) {
      for(var ii = 0; ii < rules.length; ii++) {
            let split = rules[ii].categoryDescription.split("->");
            addSearchedRules(node, split, rules[ii]);
      }
}

let cancellerPromise = null;

function childrenToList(node, list) {
      for(var ii = 0; ii < node._children.length; ii++) {
            if(node._children[ii]._isOpen) {
                  list.push(node._children[ii].title);
            }
            if(node._children[ii]._children && node._children[ii]._children.length) {
                  childrenToList(node._children[ii], list);
            }
      }
}

function* childrenFromList(node, list) {
      for(var ii = 0; ii < node._children.length; ii++) {
            if(list.includes(node._children[ii].title)) {
                  if (!node._children[ii]._isOpen && node._children[ii].numRules > 0 && node._children[ii].hasRules) {
                        yield put(actions.getRulesInstsForRule(node._children[ii]));
                  }

                  findAndToggle(node, node._children[ii]);
            }
            if(node._children[ii]._children && node._children[ii]._children.length) {
                  yield call(childrenFromList, node._children[ii], list);
            }
      }
}

//////////
//sagas
export const sagas = {
      *rootSaga() {
            yield all([
                  this.onGetRuleCategories(),
                  this.onGetRulesInstsForRule(),
                  this.onChangeFilter(),
                  this.onChangeTime(),
                  this.onGetRuleCatas(),
                  this.onChangeSite(),

                  this.onToggleOpenCategory(),
                  this.onSetSearchValue(),
                  this.onSearchUpdate(),

                  this.onClearSearch(),
                  this.onSearch(),
                  this.onGetOutcomesForRuleInst(),
                  this.onResetCategories(),
            ]);
      },

      *onResetCategories() {
            yield takeEvery(types.RESET_RULE_CATEGORIES, function*({payload}) {
                  const map = yield select(x => x.rules.map);
                  let listOfOpen = [];
                  if(map && map._children && map._children.length) {
                        childrenToList(map, listOfOpen);
                  }

                  yield put(actions.onResetRuleCategories(listOfOpen));
            });
      },

	*onClearSearch() {
		yield takeEvery(types.CLEAR_SEARCH, function*({payload}) {
                  const site = yield select(x => x.sitetree.currentSite);
                  yield put(actions.resetRuleCategories());
                  yield put(actions.getRuleCategories(site.name));
		});
	},

	*onSearch() {
		yield takeEvery([types.SEARCH, searchtypes.SEARCH_BAR_SUBMIT], function*({payload}) {
			if (payload.searchBarId === "rules/List") {
				let {searchText} = yield select(x => x.rules);

			yield put(actions.setSearchBusy());

					searchText = payload.query;

			const isNullOrWhitespace = function( input ) {
				if (typeof input === 'undefined' || input == null) return true;
				return input.replace(/\s/g, '').length < 1;
			};

			if(isNullOrWhitespace(searchText)) {
				yield put(actions.clearSearch());
			} else {
                        const state = yield select(x => x.rules);
                        const time = yield select(x => x.time.timeRange);
                        const site = yield select(x => x.sitetree.currentSite);
                        const data = yield call(
                              ruleservice.GetRuleInstanceSearch,
                              searchText,
                              state.filter,
                              DateTime.toISOstring(moment(time.startDate).add(moment().utcOffset, "m")),
                              DateTime.toISOstring(moment(time.endDate).add(moment().utcOffset, "m")),
                              (site || state.defaultSite).name
                        );
                        if (data instanceof Error) {
                              console.error(data);
                              yield put(actions.genericAction(types.ON_GET_RULEINSTS_FOR_RULE_FAILED, data));
                        } else {
                              let node = {_children: []};
                              searchedRules(node, data);
                              yield put(actions.onSearch(node, data.length));
                        }
			}
		}
			});
	},

	*onSetSearchValue() {
		yield takeEvery(types.SET_SEARCH_VALUE, function*({payload}) {
			const { searchText, hasSearched } = yield select(x => x.rules);

			if(hasSearched) {
				yield put(searchactions.searchSubmit({text: searchText, searchBarId: "rules/List"}));
			}
		});
	},

	*onSearchUpdate() {
		yield takeEvery([searchtypes.SEARCH_BAR_UPDATED], function*({payload}) {
			if(payload.searchBarId !== undefined) {
				if (payload.searchBarId === "rules/List") {
					let searchText = payload.query;
					yield put(actions.setSearchText(searchText));
				}
			}
		});
	},

      *onToggleOpenCategory() {
            yield takeEvery(types.TOGGLE_OPEN_CATEGORY, function*({payload}) {
                  if(!payload) {
                        return;
                  }

                  let rootNode = yield select(x => x.rules.map);

                  findAndToggle(rootNode, payload);

                  yield put(actions.onToggleOpenCategory(rootNode));
            });
      },

      *onGetRuleCatas() {
            yield takeEvery(types.GET_RULE_CATEGORIES, function*({ payload }) {
                  if(payload.siteName !== "all"){
                        
                  }
            });
      },

      *onChangeSite() {
            yield takeEvery([sitetreetypes.SET_CURRENT_SITE, sitetreetypes.ON_LOAD], function*({ payload }) {
                  // yield put(router.push("/Rules/" + payload.currentSite.name));
                  if(payload.currentSite){
                        yield put(actions.getRuleCategories(payload.currentSite.name));
                  }
            });
      },

      *onChangeTime() {
            yield takeEvery(timetypes.UPDATE_TIME_RANGE, function*({ payload }) {
                  const loadedTime = yield select(x => x.rules.loadedTime);
                  const time = payload.timeRange.selected != undefined ? payload.timeRange.selected : payload.timeRange;

                  const ltS = loadedTime && loadedTime.startDate ? loadedTime.startDate.valueOf() : null;
                  const ltE = loadedTime && loadedTime.endDate ? loadedTime.endDate.valueOf() : null;
                  const tS = time && time.startDate ? time.startDate.valueOf() : null;
                  const tE = time && time.endDate ? time.endDate.valueOf() : null;

                  if(tS != ltS || tE != ltE) {
                        const site = yield select(x => x.sitetree.currentSite);
                        yield put(actions.resetRuleCategories());
                        yield put(actions.getRuleCategories(site.name));
                  }
            });
      },

      *onChangeFilter() {
            yield takeEvery(types.CHANGE_FILTER, function*({ payload }) {
                  const site = yield select(x => x.sitetree.currentSite);

                  yield put(actions.resetRuleCategories());
                  yield put(actions.getRuleCategories(site.name));
            });
      },

      *onGetRulesInstsForRule() {
            yield takeEvery(types.GET_RULEINSTS_FOR_RULE, function*({ payload }) {
                  const state = yield select(x => x.rules);
                        const time = yield select(x => x.time.timeRange);
								const site = yield select(x => x.sitetree.currentSite);
                  const data = yield call(
                        ruleservice.GetRuleInstsForRule,
                        payload.ruleCategoryCode,
                        state.filter,
                        DateTime.toISOstring(time.startDate),
                        DateTime.toISOstring(time.endDate),
                        (site || state.defaultSite).name
                  );
                  if (data instanceof Error) {
                        console.error(data);
                        yield put(actions.genericAction(types.ON_GET_RULEINSTS_FOR_RULE_FAILED, data));
                  } else {
                        let node = yield select(x => x.rules.map);
                        findAndAddRules(node, payload, data);
                        yield put(actions.onGetRulesInstsForRule(node));
                  }
            });
      },

      *onGetOutcomesForRuleInst() {
            yield takeEvery(types.GET_OUTCOMES_FOR_RULE_INST, function*({ payload }) {
                  const state = yield select(x => x.rules);
                  const time = yield select(x => x.time.timeRange);

                  const data = yield call(
                        ruleservice.GetOutcomesForRuleInst,
                        payload.ruleInstanceId,
                        state.filter,
                        DateTime.toISOstring(time.startDate),
                        DateTime.toISOstring(time.endDate)
                  );
                  if(data instanceof Error) {
                        console.error(data);
                        yield put(actions.genericAction(types.ON_GET_OUTCOMES_FOR_RULE_INST_FAILED, data));
                  } else {
                        let node = yield select(x => x.rules.map);
                        findAndAddRuleOutcomes(node, payload.ruleInstanceId, data);
                        yield put(actions.onGetOutcomesForRuleInst(node));
                  }
            });
      },

      *onGetRuleCategories() {
            yield takeEvery(types.GET_RULE_CATEGORIES, function*({ payload }) {
                  const state = yield select(x => x.rules);
                        const time = yield select(x => x.time.timeRange);
								const site = yield select(x => x.sitetree.currentSite);
                  const data = yield call(
                        ruleservice.GetRuleCategories,
                        state.filter,
                        DateTime.toISOstring(moment(time.startDate).add(moment().utcOffset, "m")),
                        DateTime.toISOstring(moment(time.endDate).add(moment().utcOffset, "m")),
                        (site || state.defaultSite).name
                  );
                  if (data instanceof Error) {
                        console.error(data);
                        yield put(actions.genericAction(types.ON_GET_RULE_CATEGORIES_FAILED, data));
                  } else {

                        let node = {_children: []};
                        data.forEach(d => {
                              if(!d.displayDescription) {
                                    addCategoriesToRoot(node, d);
                              }
                        });

                        const data2 = yield call(
                              ruleservice.GetRuleCategoryDescriptions
                        );
                        if(data2 instanceof Error) {
                              console.error(data2);
                              yield put(actions.genericAction(types.ON_GET_RULE_CATEGORIES_FAILED, data2));
                        } else {
                              data2.forEach(d => {
                                    if(d.displayDescription) {
                                          for(var ii = 0; ii < node._children.length; ii++) {
                                                if(node._children[ii].title === d.ruleCategoryCode) {
                                                      node._children[ii].displayDescription = d.displayDescription;
                                                      break;
                                                }
                                          }
                                    }
                              });

                              const toBeOpened = [...state.toBeOpened];

                              yield call(childrenFromList, node, toBeOpened);

                              yield put(actions.onGetRuleCategories(node, (site || state.defaultSite).name, time));
                        }
                  }
            });
      },
};

////////
//actions
export const actions = {
      getRuleCategories(siteName) {
            return {
                  type: types.GET_RULE_CATEGORIES,
                  payload: { siteName }
            };
      },
      onGetRuleCategories(map, siteName, time) {
            return {
                  type: types.ON_GET_RULE_CATEGORIES,
                  payload: {map, siteName, time: time.selected != undefined ? time.selected : time}
            };
      },

      getRulesInstsForRule(payload) {
            return {
                  type: types.GET_RULEINSTS_FOR_RULE,
                  payload
            };
      },
      onGetRulesInstsForRule(payload) {
            return {
                  type: types.ON_GET_RULEINSTS_FOR_RULE,
                  payload
            };
      },

      toggleOpenCategory(payload) {
            return {
                  type: types.TOGGLE_OPEN_CATEGORY,
                  payload
            };
      },
      onToggleOpenCategory(payload) {
            return {
                  type: types.ON_TOGGLE_OPEN_CATEGORY,
                  payload
            }
      },

      toggleOpenRule(rule) {
            return {
                  type: types.TOGGLE_OPEN_RULE,
                  payload: { rule }
            };
      },
      getOutcomesForRuleInst(payload) {
            return {
                  type: types.GET_OUTCOMES_FOR_RULE_INST,
                  payload
            }
      },
      onGetOutcomesForRuleInst(payload) {
            return {
                  type: types.ON_GET_OUTCOMES_FOR_RULE_INST,
                  payload
            }
      },


      toggleCalendar() {
            return {
                  type: types.TOGGLE_CALENDAR,
                  payload: {}
            };
      },

      changeFilter(filter) {
            return {
                  type: types.CHANGE_FILTER,
                  payload: { filter }
            };
      },

      resetRuleCategories() {
            return {
                  type: types.RESET_RULE_CATEGORIES
            }
      },

      onResetRuleCategories(payload) {
            return {
                  type: types.ON_RESET_RULE_CATEGORIES,
                  payload
            }
      },

	setSearchValue(payload) {
		return {
			type: types.SET_SEARCH_VALUE,
			payload
		}
	},
	setSearchText(payload) {
		return {
			type: types.SET_SEARCH_TEXT,
			payload
		}
	},
	clearSearch() {
		return {
			type: types.CLEAR_SEARCH,
		}
	},
	search() {
		return {
			type: types.SEARCH
		}
	},
	onSearch(map, numOfResults) {
		return {
			type: types.ON_SEARCH,
			payload: {map, numOfResults}
		}
	},
	setSearchBusy() {
		return {
			type: types.SET_SEARCH_BUSY
		}
      },
      setTimeout(timeoutId) {
            return {
                  type: types.SET_TIMEOUT,
                  payload: timeoutId
            }
      },
      clearTimeout() {
            return {
                  type: types.CLEAR_TIMEOUT,
            }
      },

      genericAction(type, data) {
            return {
                  type,
                  payload: data
            };
      }
};



// WEBPACK FOOTER //
// ./src/ui/Rules/Rules/redux.js